// extracted by mini-css-extract-plugin
export default {"wrapper":"SideMenu_wrapper__VTixJ","menuItems":"SideMenu_menuItems__9gq40","menu":"SideMenu_menu__MI96K"};